import {
  ReferenceImage,
  ReferenceImageFromJSON,
  ReferenceImageToJSON,
  ReferenceBibliography,
  ReferenceBibliographyFromJSON,
  ReferenceBibliographyToJSON,
  SystemCode,
  SystemCodeFromJSON,
  exists,
  defaultSystemCode
} from '@/api'
import { dateToPlainFormat } from '@/utils'

/**
 * レファレンスパラメータ
 * @export
 * @interface Reference
 */
export interface Reference {
  id: number
  question: string
  level: SystemCode
  managementNo: string
  answer: string
  createdDate: string
  answerStage: SystemCode
  keyword: string
  ndc1: string
  ndc1Edition: string
  ndc2: string
  ndc2Edition: string
  ndc3: string
  ndc3Edition: string
  researchType: string
  contentsType: string
  referenceMaterials: string
  answerProcess: string
  referee: string
  preResearch: string
  free: string
  contributor: string
  questionerUserId: number
  questionerName: string
  questionerKana: string
  questionerType: string
  questionerPhone: string
  questionerFax: string
  questionerMail: string
  questionerAddress: string
  receptionWindow: string
  receptionDate: string
  receptionMethod: string
  respondent: string
  responseDate: string
  responseMethod: string
  modelNumber: string
  memo: string
  database: SystemCode
  opacShow: boolean
  createdId: number
  updatedId: number
  createdAt: string
  updatedAt: string
  bibliographies: ReferenceBibliography[]
  images: ReferenceImage[]
}

export function ReferenceFromJSON(json: any): Reference {
  return {
    id: json.id,
    question: json.question,
    level: exists(json, 'level')
      ? SystemCodeFromJSON(json.level)
      : defaultSystemCode(),
    managementNo: json.management_no,
    answer: json.answer,
    createdDate: json.created_date ? dateToPlainFormat(json.created_date) : '',
    answerStage: exists(json, 'answer_stage')
      ? SystemCodeFromJSON(json.answer_stage)
      : defaultSystemCode(),
    keyword: json.keyword,
    ndc1: json.ndc1,
    ndc1Edition: json.ndc1_edition,
    ndc2: json.ndc2,
    ndc2Edition: json.ndc2_edition,
    ndc3: json.ndc3,
    ndc3Edition: json.ndc3_edition,
    researchType: json.research_type,
    contentsType: json.contents_type,
    referenceMaterials: json.reference_materials,
    answerProcess: json.answer_process,
    referee: json.referee,
    preResearch: json.pre_research,
    free: json.free,
    contributor: json.contributor,
    questionerUserId: json.questioner_user_id,
    questionerName: json.questioner_name,
    questionerKana: json.questioner_kana,
    questionerType: json.questioner_type,
    questionerPhone: json.questioner_phone,
    questionerFax: json.questioner_fax,
    questionerMail: json.questioner_mail,
    questionerAddress: json.questioner_address,
    receptionWindow: json.reception_window,
    receptionDate: json.reception_date
      ? dateToPlainFormat(json.reception_date)
      : '',
    receptionMethod: json.reception_method,
    respondent: json.respondent,
    responseDate: json.response_date
      ? dateToPlainFormat(json.response_date)
      : '',
    responseMethod: json.response_method,
    modelNumber: json.model_number,
    memo: json.memo,
    database: exists(json, 'database')
      ? SystemCodeFromJSON(json.database)
      : defaultSystemCode(),
    opacShow: exists(json, 'opac_show') ? json.opac_show : false,
    createdId: json.created_id,
    updatedId: json.updated_id,
    createdAt: json.created_at,
    updatedAt: json.updated_at,
    bibliographies: (json.bibliographies as any[]).map(
      ReferenceBibliographyFromJSON
    ),
    images: (json.images as any[]).map(ReferenceImageFromJSON)
  }
}

export function ReferenceToJSON(value: Reference): any {
  return {
    id: value.id,
    question: value.question,
    level: value.level.code,
    management_no: value.managementNo,
    answer: value.answer,
    created_date: value.createdDate,
    answer_stage: value.answerStage.code,
    keyword: value.keyword,
    ndc1: value.ndc1,
    ndc1_edition: value.ndc1Edition,
    ndc2: value.ndc2,
    ndc2_edition: value.ndc2Edition,
    ndc3: value.ndc3,
    ndc3_edition: value.ndc3Edition,
    research_type: value.researchType,
    contents_type: value.contentsType,
    reference_materials: value.referenceMaterials,
    answer_process: value.answerProcess,
    referee: value.referee,
    pre_research: value.preResearch,
    free: value.free,
    contributor: value.contributor,
    questioner_user_id: value.questionerUserId,
    questioner_name: value.questionerName,
    questioner_kana: value.questionerKana,
    questioner_type: value.questionerType,
    questioner_phone: value.questionerPhone,
    questioner_fax: value.questionerFax,
    questioner_mail: value.questionerMail,
    questioner_address: value.questionerAddress,
    reception_window: value.receptionWindow,
    reception_date: value.receptionDate,
    reception_method: value.receptionMethod,
    respondent: value.respondent,
    response_date: value.responseDate,
    response_method: value.responseMethod,
    model_number: value.modelNumber,
    memo: value.memo,
    database: value.database.code,
    opac_show: value.opacShow,
    bibliographies: (value.bibliographies as any[]).map(
      ReferenceBibliographyToJSON
    ),
    images: (value.images as any[]).map(ReferenceImageToJSON)
  }
}
